module.exports = "/_next/static/images/FB-e5ea112d4599f470aaea343ed62517f4.svg";